import { render } from "./UpdateRecord.vue?vue&type=template&id=3cc5289e&scoped=true"
import script from "./UpdateRecord.vue?vue&type=script&lang=js"
export * from "./UpdateRecord.vue?vue&type=script&lang=js"

import "@/components/modal-responsive.css?vue&type=style&index=0&id=3cc5289e&scoped=true&lang=css&external"
import "./UpdateRecord.vue?vue&type=style&index=1&id=3cc5289e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc5289e"]])

export default __exports__